module.exports = __webpack_public_path__ + "img/heard.75db7766.png";